var RunBuffer, RunSpan, SpanBuffer, shallowObjectEqual,
  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

shallowObjectEqual = require('../util').shallowObjectEqual;

SpanBuffer = require('../span-buffer');

RunSpan = require('./run-span');

RunBuffer = (function(superClass) {
  extend(RunBuffer, superClass);

  function RunBuffer(children) {
    RunBuffer.__super__.constructor.call(this, children);
  }

  RunBuffer.prototype.getRunCount = function() {
    return this.spanCount;
  };

  RunBuffer.prototype.getRun = function(index) {
    return this.getSpan(index);
  };

  RunBuffer.prototype.getRunIndex = function(child) {
    return this.getSpanIndex(child);
  };

  RunBuffer.prototype.getRuns = function(start, count) {
    return this.getSpans(start, count);
  };

  RunBuffer.prototype.iterateRuns = function(start, count, operation) {
    return this.iterateSpans(start, count, operation);
  };

  RunBuffer.prototype.insertRuns = function(start, lines) {
    return this.insertSpans(start, lines);
  };

  RunBuffer.prototype.removeRuns = function(start, removeCount) {
    return this.removeSpans(start, removeCount);
  };

  RunBuffer.prototype.sliceRunsToRange = function(location, length) {
    return this.sliceSpansToRange(location, length);
  };

  RunBuffer.prototype.createRun = function(text) {
    return this.createSpan(text);
  };

  RunBuffer.prototype.createSpan = function(text) {
    return new RunSpan(text);
  };


  /*
  Reading attributes
   */

  RunBuffer.prototype.getAttributesAtIndex = function(characterIndex, effectiveRange, longestEffectiveRange) {
    var result, start;
    start = this.getSpanInfoAtCharacterIndex(characterIndex);
    result = start.span.attributes;
    if (effectiveRange) {
      effectiveRange.location = start.spanLocation;
      effectiveRange.length = start.span.getLength();
    }
    if (longestEffectiveRange) {
      this._longestEffectiveRange(start.spanIndex, start.span, longestEffectiveRange, function(run) {
        return shallowObjectEqual(run.attributes, result);
      });
    }
    return result;
  };

  RunBuffer.prototype.getAttributeAtIndex = function(attribute, characterIndex, effectiveRange, longestEffectiveRange) {
    var result, start;
    start = this.getSpanInfoAtCharacterIndex(characterIndex);
    result = start.span.attributes[attribute];
    if (effectiveRange) {
      effectiveRange.location = start.spanLocation;
      effectiveRange.length = start.span.getLength();
    }
    if (longestEffectiveRange) {
      this._longestEffectiveRange(start.spanIndex, start.span, longestEffectiveRange, function(run) {
        return run.attributes[attribute] === result;
      });
    }
    return result;
  };

  RunBuffer.prototype._longestEffectiveRange = function(runIndex, attributeRun, range, shouldExtendRunToInclude) {
    var currentRun, nextIndex, nextRun;
    nextIndex = runIndex - 1;
    currentRun = attributeRun;
    while (nextIndex >= 0) {
      nextRun = this.getRun(nextIndex);
      if (shouldExtendRunToInclude(nextRun)) {
        currentRun = nextRun;
        nextIndex--;
      } else {
        break;
      }
    }
    range.location = currentRun.getLocation();
    nextIndex = runIndex + 1;
    currentRun = attributeRun;
    while (nextIndex < this.getRunCount()) {
      nextRun = this.getRun(nextIndex);
      if (shouldExtendRunToInclude(nextRun)) {
        currentRun = nextRun;
        nextIndex++;
      } else {
        break;
      }
    }
    range.length = (currentRun.getLocation() + currentRun.getLength()) - range.location;
    return range;
  };


  /*
  Changing attributes
   */

  RunBuffer.prototype.sliceAndIterateRunsByRange = function(location, length, operation) {
    var slice;
    slice = this.sliceRunsToRange(location, length);
    return this.iterateSpans(slice.spanIndex, slice.count, operation);
  };

  RunBuffer.prototype.setAttributesInRange = function(attributes, location, length) {
    return this.sliceAndIterateRunsByRange(location, length, function(run) {
      return run.setAttributes(attributes);
    });
  };

  RunBuffer.prototype.addAttributeInRange = function(attribute, value, location, length) {
    return this.sliceAndIterateRunsByRange(location, length, function(run) {
      return run.addAttribute(attribute, value);
    });
  };

  RunBuffer.prototype.addAttributesInRange = function(attributes, location, length) {
    return this.sliceAndIterateRunsByRange(location, length, function(run) {
      return run.addAttributes(attributes);
    });
  };

  RunBuffer.prototype.removeAttributeInRange = function(attribute, location, length) {
    return this.sliceAndIterateRunsByRange(location, length, function(run) {
      return run.removeAttribute(attribute);
    });
  };


  /*
  Changing characters and attributes
   */

  RunBuffer.prototype.insertRunBuffer = function(runIndex, index) {};

  return RunBuffer;

})(SpanBuffer);

module.exports = RunBuffer;



/*****************
 ** WEBPACK FOOTER
 ** ./lib/run-buffer/index.js
 ** module id = 8
 ** module chunks = 0
 **/